import { FC } from "react";

const AutomationQuotes: FC = () => {
    return (
        <section className="w-full flex flex-col gap-5 px-4 py-10 lg:py-20 bg-black mb-3 lg:mb-10">
            <h2 className="text-2xl md:text-4xl text-white text-center ">
                Go Beyond Off-the-Shelf AI
            </h2>
            <p className="text-lg md:text-xl text-white text-center font-light ">
                In today's landscape, AI isn't just an option—it's a requirement. Your job is to<br className="hidden md:block" /> pick the right sales and technology partner and let us do the rest.
            </p>
        </section>
    );
};

export default AutomationQuotes;
